// extracted by mini-css-extract-plugin
export default {"projectsImageContainer":"ProjectsDetail_projectsImageContainer__64FST","imageWrapper":"ProjectsDetail_imageWrapper__yYsEu","lightGallery":"ProjectsDetail_lightGallery__TcJnK"};